// mannualUpload.jsx

import React, { useEffect, useState } from "react";
import ViewDoc from "../../assets/img/eye-icon-black.svg";
import EditDoc from "../../assets/img/penEditDarkGrey.png";
import UploadBox from "../../assets/img/File-upload-box-blue.svg";
import DocumentIcon from "../../assets/img/DocumentTypeIcon.svg";
import closeIcon from "../../assets/img/close-Dark-Icon.svg";
import DownloadDoc from "../../assets/img/download-icon-black.svg";
import UploadIcon from "../../assets/img/upload-icon-blue.svg";
import TableDigiUpload from "./TableDigiUpload";
import { FileUploader } from "react-drag-drop-files";
import { X } from "feather-icons-react/build/IconComponents";
import { getCheckDocuments, uploadDigiEduDocs, removeFile, getMRLNonDigiDocument} from "../../Actions/DigiLockerActions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Common/loader";
import { getEducation } from "../../Actions/educationActions";



// Main mannualUpload component
function MannualUpload({data,errorDocs,uploadedDocs,setUploadedDocs, mandatoryDocs, setMandatoryDocs, submitLater, uploadDocsLater,setUploadDocsLater,allChecks }) {
    const check_id = data?.check_id
    const case_check_id = data?.case_check_id
    const [showUpload, setShowUpload] = useState(data?.document_checkbox==0?false:true);
    const dispatch = useDispatch();
    const storeData = useSelector((state) => state.checkDocReducer?.checkDocData?.data);
    const storeDocs = useSelector((state) => state.UploadedDigiDoc?.uploadedDocData?.data);
    const storeDocsLoader = useSelector((state) => state.UploadedDigiDoc)
    const [isLoading, setIsLoading] = useState(false);
      
  console.log(submitLater)
    useEffect(() => {
      if(allChecks?.length>0)
      {
      //   dispatch(
      //   getCheckDocuments(allChecks)
      // );
      let payload = {
        verification_type: 1,
        check_id: check_id,
        qualification_type: data?.qualification_degree,
        org_id: data?.verification_id
      }
      dispatch(getMRLNonDigiDocument(payload, data?.check_name))
    }
      let record={}
      record.mode = "check_documents_digilocker";
        record.chkid = case_check_id
        // // record.docid =props?.formData?.checksDetails[0]?.required_documents?.[0]?.id;
        record.docid = "";
      setIsLoading(true)
      dispatch(uploadDigiEduDocs(record));
    },[])

    useEffect(() => {
      if(storeData){
        let mandatoryIds = storeData?.[data?.check_id]
  ?.filter(item => item.is_mandatory == 1)
  ?.map(item => `${case_check_id}_${item.id}`);
  console.log(mandatoryIds)
  //debugger
  if (mandatoryIds)
  {const uniqueValuesSet = new Set([...mandatoryDocs, ...mandatoryIds]);
    // Convert the Set back to an array
    const uniqueValuesArray = [...uniqueValuesSet];
  setMandatoryDocs((prevItems) => [...prevItems, ...uniqueValuesArray]);}
      }
      
    },[storeData])

    // useEffect(()=>{
    //   if(showUpload)
    //   {if(uploadDocsLater){setUploadDocsLater([...uploadDocsLater, case_check_id])}
    // else{setUploadDocsLater([case_check_id])}}
    //   else{
    //     setUploadDocsLater(uploadDocsLater?.filter(item => item !== case_check_id));
    //   }
    // },[])

    useEffect(() => {
      if(storeDocs){
        let newArray = [];
        for(const key in storeDocs){
          for (const innerkey in storeDocs[key])
          {
            newArray.push(`${key}_${innerkey}`);
          }
        }
  // const uniqueValuesSet = new Set([...uploadedDocs, ...newArray]);
  //   // Convert the Set back to an array
  //   const uniqueValuesArray = [...uniqueValuesSet];
  setUploadedDocs(newArray);
      }
      
    },[storeDocs])
    

    useEffect(() => {
    
      //debugger
      if(storeDocsLoader?.loading!=null && storeDocsLoader?.loading!= undefined &&storeDocsLoader?.loading==false){
        setIsLoading(false)
      }
          
        },[storeDocsLoader])
        console.log("docs",uploadDocsLater)
    
    const renderDragDropChildren = () => (
        <>
          <input type="file" id="myFile" class="mt-2" name="filename" />
      
          {/* <div class="w-100 bg-gray p-5 mb-3 text-center file-upload">
            <ul class="mt-4">
              <li>
                <i data-feather="upload-cloud">
                
                </i>
              </li>
              <li class="mt-4">
               
                <p class="fnt-14 text-primary" style={{ cursor: "pointer" }}>
                  Click to upload <span class="text-gray">or drag and drop</span>
                </p>
              </li>
              <li class="fnt-12 text-gray">XLS or CSV File (max. 5mb)</li>
            </ul>
          </div> */}
      
          <div className="row uploadBox justify-content-around border rounded w-100 bg-light rounded ml-1">
            <div className="col-2 align-self-center p-0">
              <img src={UploadIcon} alt="UploadIcon" width="32px" height="32px" />
            </div>
            <div className="col-8 align-self-center">
              <div className="row uploadCardText1">Click to upload</div>
              <div className="row uploadCardText2">
                upload PNG, JPG, PDF etc (max file size 5mb)
              </div>
            </div>
            
          </div>
        </>
      );

      const handleChange = (file, document_id) => {
        // // debugger
        let size=0;
        let extension_error=0;
        for(let i=0;i<file.length;i++){
           let arr = file[i]?.type.split('/')
           if(arr[arr.length-1] !== "png" && arr[arr.length-1] !== "jpg" && arr[arr.length-1] !== "pdf" && arr[arr.length-1] !== "jpeg"){
             extension_error+=1
           }
           size+=file[i]?.size
         }
      
         if(extension_error!=0){
           alert("Wrong file format");
           return false;
         }
       
          if (size> 5242880) {
            alert("File cannot be larger than 5mb");
            return false;
          }
        
        let record = {};
        record.mode = "check_documents_digilocker";
        record.chkid = case_check_id
        // // record.docid =props?.formData?.checksDetails[0]?.required_documents?.[0]?.id;
        record.docid = document_id;
        // setErrors((prev) => ({
        //   ...prev,
        //   upload: ''
        // }))
        const files = Object.keys(file).map(key => {
          const innerObject = file[key];
          return innerObject;
        });
        record.check_documents = files;
        console.log(record, file)
        setIsLoading(true);
        dispatch(uploadDigiEduDocs(record, file));
      
        
      };

      const handleCheck = ()=>{
        if(showUpload)
        {setShowUpload(!showUpload)
          setUploadDocsLater(uploadDocsLater?.filter(item => item !== case_check_id));
        }
        else{
          setShowUpload(!showUpload)
          if(uploadDocsLater && !!(!uploadDocsLater.includes(case_check_id))){
          setUploadDocsLater([...uploadDocsLater, case_check_id])}
          else{setUploadDocsLater([case_check_id])}
        } 
      }

      const callback = (res) => {
        if(res?.code == 200){
          let record={}
      record.mode = "check_documents_digilocker";
        record.chkid = case_check_id
        // // record.docid =props?.formData?.checksDetails[0]?.required_documents?.[0]?.id;
        record.docid = "";
      dispatch(uploadDigiEduDocs(record));
      dispatch(getEducation());
        }
      }

      const handleDeleteDoc = (doc_id,document_id) => {
        let record = {};
        record.mode = "check_documents";
        record.doc_chk = case_check_id
        record.doc_ids = doc_id;
        record.doc_ref = document_id
       
        console.log(record)
        setIsLoading(true);
         dispatch(removeFile(record, callback));
      }
      
    return(<>
  {/* card */}
  {isLoading && <Loader />}
  <div className="card-box p-2 py-3 mb-4 w-100">
  <div className="row head-row d-flex justify-content-between" style={{ overflowY: "hidden" }}>
    <div className="row p-0 m-0 d-flex justify-content-between pb-4 w-100">
    <div className="col-lg-6 col-md-12 col-sm-12">
      <h2 className="eduHeading">{data?.check_name}:</h2>
    </div>
    {!!submitLater && <div className="col-lg-6 col-md-12 col-sm-12 custom-checkbox d-flex align-content-center pr-3 justify-content-end">
      <input
        type="checkbox"
        className="form-check-input"
        id="exampleCheck1"
        checked={showUpload}
        onClick={ handleCheck}
        style={{ position: "inherit" }}
      />
      <label className="form-check-label pt-1 pl-2" for="exampleCheck1" >
        I will submit documents later
      </label>
    </div>}
    </div>
      
    <div className="col-12 w-100" style={{ overflowY: "hidden" }}>
    <TableDigiUpload
      className="w-100"
      headers={[
        "Course Name",
        "University/Board",
        "College/School",
        "Year of Passing",
        "Location",
      ]}
      data={data}
      type="mannual"
    />
    </div>

    {showUpload?<div className="error-text col-12 py-2">
      Note: Kindly be aware that you will be requested to resubmit the
      required documents.
    </div>:
    <div className="card-upload-box col-12 row p-0 m-0" style={{ overflowY: "hidden" }}>
      {storeData && storeData?.[check_id]?.map((doc)=>{return(<div className="col-lg-6 col-md-6 col-sm-12 py-2" style={{ overflowY: "hidden" }}>
        <div className="upload-heading pb-2">
          {doc?.document_name}{!!doc?.is_mandatory && <sup style={{color:"red"}}> * </sup>}
        </div>
        <div className="upload-box-img" >
        <FileUploader
                      hoverTitle={"Choose Files"}
                      classes={"file-upload w-100 border-0 mt-n2"}
                      handleChange={(e)=>{handleChange(e,doc?.id)}}
                      multiple={true}
                      name="file"
                      children={renderDragDropChildren()}
                      onSizeError={(file) => {
                        alert("file size larger than 5 mb");
                      }}
                      onClick={(e) => (e.target.value = null)}
                    />
        </div>
        {!!(errorDocs.indexOf(`${case_check_id}_${doc?.id}`) != -1) &&<span style={{color:"red"}}>This field is required.</span>}
        {storeDocs?.[case_check_id]?.[doc?.id]?.map((file,index)=>{
          return(
            <div className="upload-box-docs-preview d-flex justify-content-between align-content-center my-3">
          <div className="upload-box-docs-sec-1 d-flex justify-content-start align-content-center">
            <img
              src={DocumentIcon}
              alt="DocumentIcon"
              style={{
                cursor: "pointer",
                width: "16px",
                height: "16px",
              }}
            />
            <div className="docName pl-3">{doc?.document_name}{index+1}</div>
          </div>
          <div className="upload-box-docs-sec-2 d-flex justify-content-end align-content-center">
            <span>
              <img
                style={{ cursor: "pointer", marginLeft: "9px" }}
                src={ViewDoc}
                alt="ViewDoc"
                onClick={(()=>{
                const newWindow = window.open();
                newWindow.document.write(`<img src="${file?.preview_key}" />`);
              })
            }
              />
            </span>
            <span>
              <img
                style={{
                  cursor: "pointer",
                  marginLeft: "9px",
                  height: "16px",
                  width: "16px",
                }}
                src={closeIcon}
                alt="CloseIcon"
                onClick={()=>{handleDeleteDoc(doc?.id,file?.document_id)}}
              />
            </span>
          </div>
        </div>
          )
        })}
        
      </div>)})}
    </div>}
  </div>
</div>


</>
)
  
}

export default MannualUpload;